// Country to locale mapping
export const COUNTRY_LOCALE_MAP: { [key: string]: string } = {
  'nigeria': 'en-NG',
  'kenya': 'en-KE', 
  'india': 'en-IN',
  'south-africa': 'en'
};

// Known country codes
export const KNOWN_COUNTRIES = ['south-africa', 'india', 'nigeria', 'kenya'];

// Utility function to get locale from country
export const getLocaleFromCountry = (country: string): string => {
  return COUNTRY_LOCALE_MAP[country] || 'en';
};

// Utility function to detect country from URL path
export const detectCountryFromPath = (path: string): string | null => {
  const pathSegments = path.split('/')?.filter(Boolean);
  const hasCountryPrefix = pathSegments.length > 0 && KNOWN_COUNTRIES.includes(pathSegments[0]);
  return hasCountryPrefix ? pathSegments[0] : null;
};

// Utility function to get locale from URL path
export const getLocaleFromPath = (path: string): string => {
  const country = detectCountryFromPath(path);
  return country ? getLocaleFromCountry(country) : 'en';
};

// Utility function to remove country prefix from path
export const removeCountryPrefix = (path: string): string => {
  const pathSegments = path?.split('/')?.filter(Boolean);
  const hasCountryPrefix = pathSegments?.length > 0 && KNOWN_COUNTRIES.includes(pathSegments[0]);
  
  if (hasCountryPrefix) {
    return '/' + pathSegments?.slice(1).join('/') || '/';
  }
  
  return path;
};
